import { ISchema } from '@formily/react'
import { BackgroundStyleSetter } from '../../../Formily/src/setters'

export const CSSStyle: ISchema = {
  type: 'void',
  properties: {
    'style.width': {
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'SizeInput',
    },
    'style.height': {
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'SizeInput',
    },
    'style.overflowY': {
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'Select',
      'x-decorator-props': {
        tooltip: '只有设置高度才会生效'
      },
      enum: [{
        label: '滚动(默认)',
        value: 'auto',
      }, {
        label: '隐藏',
        value: 'hidden',
      }]
    },
    'style.display': {
      'x-component': 'DisplayStyleSetter',
    },
    'style[--text-align]': {
      title: '对齐方式',
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'Select',
      enum: ['left', 'center', 'right', 'justify', 'inherit'],
      "x-component-props": {
        defaultValue: 'left'
      }
    },
    'style.background': {
      'x-component': BackgroundStyleSetter,
    },
    'style.boxShadow': {
      'x-component': 'BoxShadowStyleSetter',
    },
    'style.font': {
      'x-component': 'FontStyleSetter',
    },
    'style.margin': {
      'x-component': 'BoxStyleSetter',
    },
    'style.padding': {
      'x-component': 'BoxStyleSetter',
    },
    'style.borderRadius': {
      'x-component': 'BorderRadiusStyleSetter',
    },
    'style.border': {
      'x-component': 'BorderStyleSetter',
    },
    'style.opacity': {
      'x-decorator': 'FormItem',
      'x-component': 'Slider',
      'x-component-props': {
        defaultValue: 1,
        min: 0,
        max: 1,
        step: 0.01,
      },
    },
  },
}
